import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';

type DynamicInvoiceViewSectionProps = React.PropsWithChildren<{
  title: string;
}>;

export const DynamicInvoiceViewSection: React.FC<DynamicInvoiceViewSectionProps> = ({ title, children }) => {
  return (
    <Stack>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
          marginBottom: "10px"
        }}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
